import React from 'react'
import * as classNames from 'classnames'
import { noop } from 'lodash'
import { formatNumber } from '../../utils'

const SimpleTextBox = ({
  id,
  value,
  postfix,
  fontSize = 'md',
  type = 'default',
  bold = true,
  decoration = 'none', //success or danger
  action = noop
}) => {
  const formattedValue = isNaN(value) ? value : formatNumber(value)
  return (
    <div
      id={id}
      className={classNames('kpi-card', {
        [`type-${type}`]: true,
        'green-border': decoration === 'success',
        'red-border': decoration === 'danger'
      })}
      onClick={action}
    >
      <div className='ovs-group-span'>
        <span
          className={classNames('card-value', {
            [`font-size-${fontSize}`]: true,
            'bold-style': bold
          })}
        >
          {postfix ? `${formattedValue} ${postfix}` : formattedValue}
        </span>
      </div>
    </div>
  )
}

export default SimpleTextBox
